import React from 'react';

interface ResponsiveGridProps {
  children: React.ReactNode;
  viewMode: 'liste' | 'card';
  className?: string;
}

const ResponsiveGrid: React.FC<ResponsiveGridProps> = ({ 
  children, 
  viewMode, 
  className = "" 
}) => {
  if (viewMode === 'liste') {
    return (
      <div className={`space-y-3 ${className}`}>
        {children}
      </div>
    );
  }

  // Mode card - grille responsive
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 ${className}`}>
      {children}
    </div>
  );
};

export default ResponsiveGrid;
